export default function MonthCell({ cell, onClick, label }) {
  const { status, n_pdf } = cell || { status: "vuoto", n_pdf: 0 };

  let cls = "pa-cell pa-cell-vuoto";
  let content = "—";
  let title = `${label} - nessun PDF caricato`;

  if (status === "pdf_caricati") {
    cls = "pa-cell pa-cell-pdf";
    content = `${n_pdf}`;
    title = `${label} - ${n_pdf} PDF caricati, Excel da generare`;
  } else if (status === "excel_pronto") {
    cls = "pa-cell pa-cell-ok";
    content = "✓";
    title = `${label} - Excel pronto`;
  } else if (status === "acquisito_esterno") {
    cls = "pa-cell pa-cell-esterno";
    content = "✓";
    title = `${label} - già acquisito esternamente (fuori dal portale)`;
  } else if (status === "errore") {
    cls = "pa-cell pa-cell-errore";
    content = "!";
    title = `${label} - errore nell'ultima generazione`;
  }

  return (
    <button
      onClick={onClick}
      className={cls}
      title={title}
      aria-label={title}
      data-testid={`month-cell-${label.toLowerCase()}`}
    >
      {content}
    </button>
  );
}
